import { INutrient } from '@interfaces/_recommendation';
import Tooltip from '@components/common/presentational/tooltip/tooltip';

import styles from './nutrients-list.styles';

export function NutrientsList({ nutrients, onlyKey }: { nutrients: INutrient[], onlyKey?: boolean }) {
    return (
        <span className={styles.container}>
            {nutrients &&
                Object.values(nutrients).map((nutrient, index) =>
                    (nutrient.isKey || !onlyKey) &&
                        <div className="ing-square ing-cho-line ml-0 mr-1 mb-1" key={index}>
                            <Tooltip title={nutrient.title} description={nutrient.description}>
                                <img loading="lazy" alt={nutrient.title} src={nutrient.icon} />
                            </Tooltip>
                        </div>
                )
            }
        </span>
    );
}